export default "__VITE_ASSET__DaUoIh4K__"